function Cart(){

    return(
        <div style={{display:'flex', alignItems:'center', justifyContent:'center',minHeight:'85vh'}}><h1>Your cart is empty</h1></div>

    )
    
}
export default Cart;